import { render, staticRenderFns } from "./UserPersonalData.vue?vue&type=template&id=189e79ad&"
import script from "./UserPersonalData.vue?vue&type=script&lang=js&"
export * from "./UserPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports